import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { onUserSearch } from "../../controller/UserController";
import 'react-toastify/dist/ReactToastify.css';
import AuthUtility from "../../util/AuthUtility";
import { Col, Button, Row, Container, Card, Form, InputGroup, Table, Pagination, Badge } from 'react-bootstrap';
import SearchIcon from '@mui/icons-material/Search';
import InfoIcon from '@mui/icons-material/Info';
import { UserEntity } from '../../dto/User/UserEntity';
import { UserListEntity } from '../../dto/User/UserListEntity';
import { Page } from "../../dto/page/Page";
import { UserSearch } from "../../dto/User/UserSearch";
import toast, { Toaster } from 'react-hot-toast';
import { getUserKycLevel, getUserKycStatus, getUserStatus, getUserType } from "../../app/AppConst";

const UserList = () => {
    const navigate = useNavigate();

    useEffect(() => {
        if (!AuthUtility.isUserLoggedIn()) {
            navigate("/login");
            window.location.reload();
        }
    }, []);

    // USER LIST
    const [users, setUsers] = useState<UserListEntity>({
        data: []
    });

    const [search, setSearch] = useState<UserSearch>({
        limit: 10
    });

    // ---- Search submit
    const searchSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        load(0); // reset to first page on new search
    };

    // ---- Pagination click
    const changePage = (page: number) => {
        if (!users.page) return;
        if (page < 0 || page >= users.page.totalPages) return;
        load(page);
    };

    const load = async (page: number = 0) => {
        const params: UserSearch = {
            ...search,
            offset: page
        };

        const response = await onUserSearch(params);

        if (response.status !== 0) {
            toast.error("Хэрэглэгч уншихад алдаа гарлаа");
            return;
        }

        const pageable = response.data;

        const pageInfo: Page = {
            limit: search.limit,
            totalElements: pageable.totalElements,
            totalPages: pageable.totalPages,
            offset: page
        };

        const beans: Array<UserEntity> = pageable.beans;

        setUsers({
            page: pageInfo,
            data: beans
        });

        setSearch(prev => ({ ...prev, offset: page }));
    };

    return (
        <div>
            <Container fluid>
                <h3><a onClick={() => navigate(-1)}><big>&#8592;</big></a>Хэрэглэгч</h3>
                <Row className="d-flex justify-content-center align-items-center">
                    <Col md={12} lg={12} xs={12}>
                        <Card>
                            <Card.Header>
                                <Form onSubmit={searchSubmit}>
                                    <Row>
                                        <Col md={3}>
                                            <Form.Group className="mb-3" controlId="name">
                                                <Form.Label className="text-center">Нэр</Form.Label>
                                                <Form.Control size="sm" type="text" 
                                                onChange={(event) => {
                                                    const value = event.target.value;
                                                    if (value !== "") {
                                                        setSearch({
                                                            ...search,
                                                            name: event.target.value
                                                        })
                                                    } else {
                                                        const { name, ...rest } = search;
                                                        setSearch(rest);
                                                    }
                                                }} />
                                            </Form.Group>
                                        </Col>
                                        <Col md={3}>
                                            <Form.Group className="mb-3" controlId="phoneNo">
                                                <Form.Label className="text-center">
                                                    Утасны дугаар
                                                </Form.Label>
                                                <Form.Control size="sm" type="text" 
                                                onChange={(event) => {
                                                    const value = event.target.value;
                                                    if (value !== "") {
                                                        setSearch({
                                                            ...search,
                                                            phoneNo: event.target.value
                                                        })
                                                    } else {
                                                        const { phoneNo, ...rest } = search;
                                                        setSearch(rest);
                                                    }
                                                }} />
                                            </Form.Group>
                                        </Col>
                                        <Col md={3}>
                                            <Form.Group className="mb-3" controlId="email">
                                                <Form.Label className="text-center">
                                                      Имэйл
                                                </Form.Label>
                                                <Form.Control size="sm" type="text" 
                                                onChange={(event) => {
                                                    const value = event.target.value;
                                                    if (value !== "") {
                                                        setSearch({
                                                            ...search,
                                                            email: event.target.value
                                                        })
                                                    } else {
                                                        const { email, ...rest } = search;
                                                        setSearch(rest);
                                                    }
                                                }} />
                                            </Form.Group>
                                        </Col>
                                        <Col md={3}>
                                            <Form.Group className="mb-3" controlId="mnRegistrationNo">
                                                <Form.Label className="text-center">
                                                      Регистрийн дугаар
                                                </Form.Label>
                                                <Form.Control size="sm" type="text" 
                                                onChange={(event) => {
                                                    const value = event.target.value;
                                                    if (value !== "") {
                                                        setSearch({
                                                            ...search,
                                                            regNo: event.target.value
                                                        })
                                                    } else {
                                                        const { regNo, ...rest } = search;
                                                        setSearch(rest);
                                                    }
                                                }} />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={3}>
                                            <Form.Group className="mb-3" controlId="status">
                                                <Form.Label>Төрөл</Form.Label>
                                                <InputGroup className="mb-3">
                                                    <Form.Select size="sm" 
                                                    onChange={(event) => {
                                                        const value = event.target.value;
                                                        if (value !== "") {
                                                            setSearch({
                                                                ...search,
                                                                type: event.target.value
                                                            })
                                                        } else {
                                                            const { type, ...rest } = search;
                                                            setSearch(rest);
                                                        }
                                                    }}>
                                                        <option></option>
                                                        <option value="INDIVIDUAL">ИРГЭН</option>
                                                        <option value="COMPANY">БАЙГУУЛЛАГА</option>
                                                    </Form.Select>
                                                </InputGroup>
                                            </Form.Group>
                                        </Col>
                                        <Col md={3}>
                                            <Form.Group className="mb-3" controlId="limit">
                                                <Form.Label>Багцлах</Form.Label>
                                                <InputGroup className="mb-3">
                                                    <Form.Select size="sm" 
                                                    onChange={(event) => setSearch({
                                                        ...search,
                                                        limit: parseInt(event.target.value)
                                                    })}>
                                                        <option value="10">10</option>
                                                        <option value="25">25</option>
                                                        <option value="0">Бүгд</option>
                                                    </Form.Select>
                                                    <Button size="sm" type="submit">
                                                        <SearchIcon fontSize="small"/>
                                                    </Button>
                                                </InputGroup>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </Form>
                            </Card.Header>
                            <Card.Body>
                                <Table hover>
                                    <thead>
                                        <tr>
                                            <th>Created At</th>
                                            <th>Type</th>
                                            <th>Status</th>
                                            <th>Nickname</th>
                                            <th>Name</th>
                                            <th>Phone</th>
                                            <th>Register No</th>
                                            <th>Tax No</th>
                                            <th>Kyc Status</th>
                                            <th>Kyc Level</th>
                                            <th><InfoIcon /></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {users.data.length === 0 && (
                                            <tr>
                                                <td className="text-muted">
                                                    Илэрц олдсонгүй
                                                </td>
                                            </tr>
                                        )}

                                        {
                                            users.data.map((user, userIdx) => {
                                                return (
                                                    <tr key={userIdx}>
                                                        <td>{user.createdAt
                                                        ? new Date(user.createdAt).toLocaleString()
                                                        : "-"}</td>
                                                        <td>
                                                            <Badge bg={getUserType(user.type)}>{user.type}</Badge>
                                                        </td>
                                                        <td>
                                                            <Badge bg={getUserStatus(user.status)}>{user.status}</Badge>
                                                        </td>
                                                        <td>{user.nickname}</td>
                                                        <td>
                                                        {user.individualProfile?.accountId !== null
                                                        ? `${user.individualProfile?.firstName ?? ""} ${user.individualProfile?.lastName ?? ""}`.trim()
                                                        : user.companyProfile?.companyName ?? ""}
                                                        </td>
                                                        <td>{user.phoneNo}</td>
                                                        <td>{user.individualProfile?.accountId !== null ? (user.individualProfile?.regNo) : user.companyProfile?.regNo}</td>
                                                        <td>{user.companyProfile?.taxNo}</td>
                                                        <td><Badge bg={getUserKycStatus(user.kycStatus)}>{user.kycStatus}</Badge></td>
                                                        <td><Badge bg={getUserKycLevel(user.kycLevel)}>{user.kycLevel}</Badge></td>
                                                        <th><a href={`/user/${user.phoneNo}`}><InfoIcon /></a></th>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </Table>
                            </Card.Body>
                        </Card>
                    </Col>  
                </Row>

                {users.page && users.page.totalPages > 1 && (() => {
                const page = users.page;   // now TypeScript knows it's NOT undefined

                return (
                    <Row>
                        <Col className="d-flex justify-content-start mt-3">
                            <Pagination>
                                <Pagination.First
                                    disabled={page.offset === 0}
                                    onClick={() => changePage(0)}
                                />

                                <Pagination.Prev
                                    disabled={page.offset === 0}
                                    onClick={() => changePage(page.offset - 1)}
                                />

                                {Array.from({ length: page.totalPages })
                                    .slice(
                                        Math.max(page.offset - 2, 0),
                                        Math.min(page.offset + 3, page.totalPages)
                                    )
                                    .map((_, idx) => {
                                        const pageNumber =
                                            Math.max(page.offset - 2, 0) + idx;

                                        return (
                                            <Pagination.Item
                                                key={pageNumber}
                                                active={pageNumber === page.offset}
                                                onClick={() => changePage(pageNumber)}
                                            >
                                                {pageNumber + 1}
                                            </Pagination.Item>
                                        );
                                    })}

                                <Pagination.Next
                                    disabled={page.offset + 1 >= page.totalPages}
                                    onClick={() => changePage(page.offset + 1)}
                                />

                                <Pagination.Last
                                    disabled={page.offset + 1 >= page.totalPages}
                                    onClick={() => changePage(page.totalPages - 1)}
                                />
                            </Pagination>
                        </Col>
                    </Row>
                );
            })()}
            </Container>
        </div>
    )
}

export default UserList;